import { getAllGroups, addGroup, deleteGroup, updateGroup, queryWindowsGroups } from "src/actions/groupActions";

export const REQUEST_GROUPS = "request_groups";
export const RECEIVE_GROUPS = "receive_groups";
export const RECEIVE_GROUPS_ERROR = "receive_groups_error";
export const REQUEST_ADD_GROUP = "request_add_group";
export const RECEIVE_ADD_GROUP = "receive_add_group";
export const ADD_GROUP_ERROR = "add_group_error";
export const REQUEST_DELETE_GROUP = "request_delete_group";
export const RECEIVE_DELETE_GROUP = "receive_delete_group";
export const DELETE_GROUP_ERROR = "delete_group_error";
export const REQUEST_UPDATE_GROUP = "request_update_group";
export const RECEIVE_UPDATE_GROUP = "receive_update_group";
export const UPDATE_GROUP_ERROR = "update_group_error";
export const REQUEST_QUERY_WINDOWS = "request_query_windows";
export const RECEIVE_QUERY_WINDOWS = "receive_query_windows";
export const RECEIVE_WINDOWS_ERROR = "receive_windows_error";

const fetchGroups = () => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_GROUPS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_GROUPS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: RECEIVE_GROUPS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const { groups } = await getAllGroups();
			return onSuccess(groups);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

const addGroupRedux = (name, users, models, ldap) => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_ADD_GROUP,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_ADD_GROUP,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: ADD_GROUP_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await addGroup(name, users, models, ldap);
			const { createdGroup } = response;

			return onSuccess(createdGroup);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

const deleteGroupRedux = groupId => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_DELETE_GROUP,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_DELETE_GROUP,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: DELETE_GROUP_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await deleteGroup(groupId);
			const { deletedGroup } = response;

			return onSuccess(deletedGroup);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};
const updateGroupRedux = values => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_UPDATE_GROUP,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_UPDATE_GROUP,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: UPDATE_GROUP_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await updateGroup(values);
			const { updatedGroup } = response;

			return onSuccess(updatedGroup);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

const queryWindowsGroupsRedux = query => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_QUERY_WINDOWS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_QUERY_WINDOWS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: RECEIVE_WINDOWS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const { groups } = await queryWindowsGroups(query);
			return onSuccess(groups);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

export { fetchGroups, addGroupRedux, deleteGroupRedux, updateGroupRedux, queryWindowsGroupsRedux };
